export enum ProjectSteps {
  COLLECTION_SETTINGS = 'COLLECTION_SETTINGS',
  PROJECT_OVERVIEW = 'PROJECT_OVERVIEW',
  UPLOAD_ASSETS = 'UPLOAD_ASSETS',
  LAYERS_CONFIGURATION = 'LAYERS_CONFIGURATION',
  ART_MIXER_SETTINGS = 'ART_MIXER_SETTINGS',
  VALIDATE_ARTWORK = 'VALIDATE_ARTWORK',
  GENERATE_ARTWORK = 'GENERATE_ARTWORK',
  ARTWORK_OVERVIEW = 'ARTWORK_OVERVIEW',
  SMART_CONTRACT = 'SMART_CONTRACT',
  FINALIZE = 'FINALIZE',
}
export const INITIAL_STEP = ProjectSteps.COLLECTION_SETTINGS;
